import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AuthService } from '@ibc-features/user/services/auth.service';
import { WindowComponent } from '@ibc-shared/components/window/window.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-recover-password-confirmation',
  imports: [TranslateModule, WindowComponent, ReactiveFormsModule, RouterLink],
  templateUrl: './recover-password-confirmation.component.html',
  styleUrl: './recover-password-confirmation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecoverPasswordConfirmationComponent {
  private readonly auth = inject(AuthService);

  protected form = new FormGroup({
    email: new FormControl<string>('', [Validators.required, Validators.email]),
  });

  protected recoveryComplete = signal<boolean>(false);
  protected isSubmitting = signal(false);
  protected errorMessage = signal(false);

  protected setErrorMessage(field: string): string {
    return field;
  }

  protected onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
    }

    this.isSubmitting.set(true);
    this.errorMessage.set(false);

    const email: string = this.form.value.email!;

    this.auth.resetPassword(email).subscribe({
      next: () => {
        this.form.reset();
        this.recoveryComplete.set(true);
        this.isSubmitting.set(false);
      },
      error: err => {
        if (err.status === 429) {
          this.setErrorMessage('features.resetPassword.form.errors.tooManyRequests');
        } else {
          this.setErrorMessage('features.resetPassword.form.errors.notWorking');
        }
        this.form.reset();
        this.isSubmitting.set(false);
        this.errorMessage.set(true);
      },
    });
  }
}
